// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__+E4hw","column__used-stock":"styles_column__used-stock__QH+Ne"};